export default {
  reward_title: "Récompenses d'invitation",
  reward_desc_dynamic:
    "Pour chaque ami que vous invitez à s'inscrire avec succès, vous recevrez {0} crédits de calcul en récompense",
  invite_friend: "Inviter des amis",
  friend_email: "Email de l'ami",
  email_placeholder: "Veuillez saisir l'email de votre ami",
  send_invite: "Envoyer l'invitation",
  invite_instructions: "Instructions d'invitation",
  email_invitation_validity_dynamic: "Les invitations par email sont valides pendant {0} jours",
  link_invitation_permanent: "Les invitations par lien sont valables en permanence",
  instruction_1_dynamic:
    "Pour chaque invitation réussie, vous et votre ami recevrez {0} crédits de calcul",
  instruction_2:
    "Les récompenses seront automatiquement attribuées après que votre ami aura accepté l'invitation et se sera inscrit avec succès",
  instruction_3:
    "Les crédits de récompense peuvent être utilisés pour les calculs d'émissions de carbone et sont valables selon votre plan d'abonnement",
  invite_stats: "Statistiques d'invitation",
  total_invites: "Total des invitations",
  accepted_invites: "Invitations acceptées",
  reward_credits: "Crédits de récompense",
  invite_link: "Lien d'invitation personnel",
  reward_rules: "Règles de récompense",
  reward_rule_1_dynamic:
    "Pour chaque invitation réussie, vous recevrez {0} crédits de calcul en récompense",
  reward_rule_2:
    "Les crédits de récompense seront automatiquement ajoutés à votre compte et peuvent être utilisés pour les calculs d'émissions de carbone",
  reward_rule_3:
    "En cas de détection de fraude, nous nous réservons le droit d'annuler les récompenses et de bannir le compte",
  email_required: "Veuillez saisir une adresse email",
  email_invalid: "Format d'email invalide",
  invite_sent: "Invitation envoyée",
  send_failed: "Échec de l'envoi de l'invitation",
  fetch_failed: "Échec de la récupération des informations d'invitation",
  copy_success: "Copié avec succès",
  email_invitation: "Invitation par email",
  link_invitation: "Invitation par lien",
  status_pending: "En attente",
  status_accepted: "Acceptée",
  status_expired: "Expirée",
  reward_issued: "Attribuée",
  pending: "En attente",
  reward_pending_tip:
    "Les récompenses seront attribuées après que votre ami aura effectué son premier calcul",
  expiring_soon: "Expire bientôt",
  no_invitations: "Aucun enregistrement d'invitation",
  invitee_id: "ID de l'invité",
  type: "Type d'invitation",
  email: "Email",
  status: "Statut",
  reward_status: "Statut de la récompense",
  invite_time: "Heure d'invitation",
  expire_time: "Date d'expiration",
  my_invitations: "Mes invitations",
  invite_created_title: "Lien d'invitation",
  invite_created_desc:
    "Échec de l'envoi de l'email. Veuillez envoyer manuellement le lien suivant à votre ami :",
  total_invitations: "Total {0} enregistrements",
  search_invitations: "Rechercher des invitations...",
  confirm: "Confirmer",
};
